"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _reactVirtualized = require("react-virtualized");
var _constants = require("./constants");
var _helpers = _interopRequireDefault(require("./helpers"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var VirtualizedList = function VirtualizedList(_ref) {
  var children = _ref.children,
    item = _ref.item,
    listHeight = _ref.listHeight;
  return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, {
    disableHeight: true
  }, function (_ref2) {
    var width = _ref2.width;
    return listHeight && /*#__PURE__*/_react["default"].createElement(_reactVirtualized.List, {
      rowCount: R.length(item.list),
      width: width,
      height: (0, _helpers["default"])(item.list, listHeight),
      rowHeight: _constants.ROW_HEIGHT,
      rowRenderer: function rowRenderer(_ref3) {
        var index = _ref3.index,
          style = _ref3.style;
        return children && children({
          idx: index,
          style: style,
          subItem: R.path(['list', index], item)
        });
      },
      overscanRowCount: 3
    });
  });
};
VirtualizedList.propTypes = {
  children: _propTypes["default"].func.isRequired,
  item: _propTypes["default"].shape({
    list: _propTypes["default"].oneOf([_propTypes["default"].array])
  }).isRequired,
  listHeight: _propTypes["default"].number
};
VirtualizedList.defaultProps = {
  listHeight: null
};
var _default = exports["default"] = VirtualizedList;